export default function _sharePage() {
    // console.log('geoform');
    // Check if the module exists before doing anything
    const sharePageComponentExists = !!document.querySelector('.share-page');

    // If the module exists, do whatever we need to
    if (sharePageComponentExists) {
        const clipboardBtn = document.querySelector('.clipboard--btn');
        const clipboardMsgContainer = document.querySelector('.clipboard--msg');

        clipboardBtn.addEventListener('click', async () => {
            if (!navigator.clipboard) {
                // Clipboard API not available
                return;
            }

            const url = window.location.href;
            try {
                await navigator.clipboard.writeText(url);
                clipboardMsgContainer.classList.toggle('hide');
                setTimeout(() => {
                    clipboardMsgContainer.classList.toggle('hide');
                }, 1000);
            } catch (err) {
                console.error('Failed to copy!', err);
            }
        });
    }
}
_sharePage();
